module.exports = __webpack_public_path__ + "img/modules-indoor-linear.d8bfb8f5.jpg";